import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EmailEditor from 'react-email-editor';
import { Container, Grid, TextField } from '@material-ui/core';
import { Title } from '../AdminBanner/style';
import { CommonButton } from '../common/Buttons';

import { getEmailTemplates, updateTemplateById, saveTemplate } from '../../actions/Communicated';
import AddTemplate from '../Forms/AddTemplate';

const ManageCommunicated = ({ history, match }) => {
  const dispatch = useDispatch();

  const { templates, user } = useSelector(({ communicated, auth }) => ({
    templates: communicated?.templates || [],
    user: auth?.userData?.userLogado?.adm_login || null
  }));

  const emailEditorRef = useRef(null);
  const [formData, setFormData] = useState({});
  const [titleTemplate, setTitleTemplate] = useState('');
  const [emailCanal, setEmailCanal] = useState('');
  const [update, setUpdate] = useState(false);

  useEffect(() => {
    dispatch(getEmailTemplates());
    setUpdate(false);
  }, [update]);

  useEffect(() => {
    loadTemplate();
  }, [formData]);

  const loadTemplate = (_id) => {
    if (!_id) return;
    const templateSelect = templates.filter((t) => {
      return t.id === parseInt(_id)
    });
    setTitleTemplate(templateSelect[0]?.title)
    setEmailCanal(templateSelect[0]?.channelName)
    setFormData({ ...formData, title: templateSelect[0]?.title });
    if (templateSelect[0]?.emailTemplate) emailEditorRef.current.editor.loadDesign(templateSelect[0]?.emailTemplate);
  };

  const handleSave = useCallback(() => {
    emailEditorRef.current.editor.exportHtml(async ({ design }) => {
      dispatch(await saveTemplate({ title: formData.title, channelName: formData.channelName, emailTemplate: design, userWhoCreated: user })).then(history.go(0));
    });
  });

  const handleUpdate = useCallback(() => {
    emailEditorRef.current.editor.exportHtml(({ design }) => {
      dispatch(updateTemplateById({ id: parseInt(formData?.channel), title: titleTemplate, channelName: emailCanal, emailTemplate: design })).then(setTimeout(() => { history.go(0) }, 1000));
    });
  });

  const handleTitle = useCallback((title) => {
    setTitleTemplate(title)
    setFormData({ ...formData, title })
  });

  const handleEmail = useCallback((channelName) => {
    setEmailCanal(channelName)
    setFormData({ ...formData, channelName })
  });


  return (
    <>
      <Container>
        <Title variant="h2">Modelos de Comunicado</Title>

        <AddTemplate loadTemplate={loadTemplate} templates={templates} formData={formData} setFormData={setFormData} />
        <TextField
          label="Titulo do Novo Template"
          fullWidth
          value={titleTemplate}
          onChange={(e) => handleTitle(e.target.value)}
          margin="normal"
          variant="outlined"
        />
        <TextField
          label="Email Canal"
          fullWidth
          value={emailCanal}
          onChange={(e) => handleEmail(e.target.value)}
          margin="normal"
          variant="outlined"
        />
        <EmailEditor
          ref={emailEditorRef}
          onLoad={loadTemplate}
          options={{
            locale: 'pt-BR',
          }}
        />
        <Grid container justify={'space-between'} style={{ marginTop: 15 }}>
          <Grid item xs={2}>
            <CommonButton action={() => history.push('/admin/gestao_de_Comunicados')} label={'Voltar'} />
          </Grid>
          <Grid item xs={2}>
            <CommonButton action={() => formData?.channel ? handleUpdate() : handleSave()} label={formData?.channel ? "Atualizar" : "Salvar"} />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default ManageCommunicated;
